import { render, staticRenderFns } from "./VideoCallRoom.vue?vue&type=template&id=2d995da8&"
import script from "./VideoCallRoom.vue?vue&type=script&lang=js&"
export * from "./VideoCallRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports